<section
  class="dashboard-aside-links-section"
  [attr.aria-labelledby]="sectionId() + '-title'">
  <div class="dashboard-aside-links-section__content">
    <h4 [id]="sectionId() + '-title'" class="filters-title">
      {{ titleKey() | translate }}
    </h4>

    <nav
      class="dashboard-aside-links-section__list"
      [attr.aria-label]="titleKey() | translate">
      @for (link of links(); track link.id) {
        @if (link.route) {
          <a
            class="dashboard-aside-links-section__link"
            [routerLink]="link.route"
            [queryParams]="link.queryParams ?? null">
            <i-tabler [name]="link.icon" class="dashboard-aside-links-section__icon" aria-hidden="true"></i-tabler>
            <span class="dashboard-aside-links-section__label">{{ link.labelKey | translate }}</span>
            <i-tabler name="chevron-right" class="dashboard-aside-links-section__chevron" aria-hidden="true"></i-tabler>
          </a>
        } @else {
          <button
            type="button"
            class="dashboard-aside-links-section__link"
            (click)="onLinkClick(link, $event)">
            <i-tabler [name]="link.icon" class="dashboard-aside-links-section__icon" aria-hidden="true"></i-tabler>
            <span class="dashboard-aside-links-section__label">{{ link.labelKey | translate }}</span>
            <i-tabler name="chevron-right" class="dashboard-aside-links-section__chevron" aria-hidden="true"></i-tabler>
          </button>
        }
      }
    </nav>
  </div>

  @if (footnoteKey()) {
    <hr class="filters-aside-divider" aria-hidden="true" />

    <p class="dashboard-aside-links-section__footnote">
      {{ footnoteKey()! | translate }}
    </p>
  }
</section>
